export const useCases = [
  {
    id: "01",
    title: "Gaming and Entertainment",
    desc: `Virtual gaming experiences and immersive entertainment are among the primary drivers of Metaverse development, providing users with engaging and interactive virtual worlds`,
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1750159835/use_img_one_geik6w.webp",
  },
  {
    id: "02",
    title: "Social Interactions and Communication",
    desc: `The Metaverse enables social connections, allowing users to interact, communicate, and collaborate with others, regardless of physical location`,
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1750159836/use_img_two_yy4kna.webp",
  },
  {
    id: "03",
    title: "Education and Remote Learning",
    desc: `The Metaverse presents opportunities for immersive and interactive educational experiences, facilitating remote learning, skill-building, and knowledge-sharing`,
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1750159836/use_img_three_gxbxr8.webp",
  },
  {
    id: "04",
    title: "Virtual Commerce and Digital Assets",
    desc: `The Metaverse creates a platform for virtual commerce, where users can buy, sell, and trade digital assets, virtual goods, and experiences`,
    img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1750159834/use_img_four_joolze.webp",
  },
];
